<div class="price-bar-button" [class.error]="error" (dblclick)="copyLastPriceJson()">
    <span class="text" *ngIf="!error">
        <app-loading-spinner class="loading-spinner-small" *ngIf="loadingPrice"></app-loading-spinner>
        {{ currentPriceInEuroCents | formatEuroCents: true }}
    </span>
    <span *ngIf="error" class="error-message">{{ 'configurator:price:error:label' | translate }}</span>
</div>
